import {
  requestPackHistoryList,
  requestPackHistoryDetail,
} from '@/api/packHistory';

const state = {
  packHistoryList: null,
  currentPackHistory: null,
  selectedMode: '0',
};

const getters = {
  packHistoryList: (state) => state.packHistoryList,
  currentPackHistory: (state) => state.currentPackHistory,
  selectedMode: (state) => state.selectedMode,
};

const actions = {
  async setPackHistoryList({ commit, dispatch, rootGetters }, { param, pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestPackHistoryList({ csrfToken, postParams: param, pageNumber });
    commit('setPackHistoryList', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    await dispatch('setIsLoading', false, { root: true });
  },
  clearPackHistoryList({ commit }) {
    commit('setPackHistoryList', null);
  },
  async setCurrentPackHistory({ commit, dispatch }, { packHistoryId }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPackHistoryDetail({ packHistoryId });
    commit('setCurrentPackHistory', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  setSelectedMode({ commit }, { mode }) {
    commit('setSelectedMode', mode);
  },
};

const mutations = {
  setPackHistoryList(state, packHistoryList) {
    state.packHistoryList = packHistoryList;
  },
  setCurrentPackHistory(state, currentPackHistory) {
    state.currentPackHistory = currentPackHistory.detail;
  },
  setSelectedMode(state, mode) {
    state.selectedMode = mode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
